const SORT_CODE = 'sortcode';

export default function casePatientHospitalizationComparator(
  valueA,
  valueB,
  nodeA,
  nodeB
) {
  const sortCodeA = nodeA.data[SORT_CODE];
  const sortCodeB = nodeB.data[SORT_CODE];

  let result;
  if (valueA > valueB) {
    result = 1;
  } else if (valueA < valueB) {
    result = -1;
  } else if (sortCodeA > sortCodeB) {
    result = 1;
  } else if (sortCodeA < sortCodeB) {
    result = -1;
  } else {
    result = 0;
  }
  return result;
}
